<div class="msb" id="msb">
  <nav class="navbar navbar-default" role="navigation">
    <div class="side-menu-container">
      <ul class="nav navbar-nav">

        <li class="nav-item click-menu">
          <div class="my-3">
            <a href="admin/dashboard"><i class="fas fa-tachometer-alt"></i> Dashboard</a>
          </div>
        </li>
        <li class="nav-item click-menu">
          <div class="my-3">
            <a href="admin/chats"><i class="fas fa-puzzle-piece"></i> Mensajes</a>
          </div>
        </li>
        <li class="nav-item">
          <div class="my-3 click-menu">
          <a href="admin/perfil"><i class="fas fa-heart"></i> Perfil</a>
          </div>
        </li>
      </ul>
    </div>
  </nav>  
</div>